import * as React from "react";
import { styled } from "styled-components";

import { NavigateButton } from "affinityUI/elements/button";
import { Layout } from "affinityUI/structures/layout";

const Wrapper = styled.div`
  margin-bottom: 2rem;
`;

export const SetPasswordSuccess: React.FC = () => {
  return (
    <Layout title="Your password is set" publicLayout>
      <Wrapper>Please click below to go to the log in page</Wrapper>
      <NavigateButton to="/login">Log in</NavigateButton>
    </Layout>
  );
};
